import React from 'react';

import DonutPagesChart from '../components/DonutPagesChart';



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: string;
	}>;
};



const DomainChart: React.FC<Props> = (props) => {
	const {
		data,
	} = props;

	const randomColors = React.useMemo(
		() => [
			'#367be2',
			'#FE8719',
		],
		[]
	);

	return (
		<DonutPagesChart
			data={data}
			name="domain"
			percentageFactor={100}
			randomColors={randomColors}
		/>
	);
};



export default React.memo(DomainChart);
